import { UsersPage } from './../pages/users/users';
import { Component, ViewChild } from '@angular/core';
import { Nav, Platform } from 'ionic-angular';
import { StatusBar } from '@ionic-native/status-bar';
//import { SplashScreen } from '@ionic-native/splash-screen';

import { HomePage } from '../pages/home/home';

import { LoginPage } from '../pages/login/login';
import { CompaniesPage } from '../pages/companies/companies';
import { AuthService } from '../services/auth/auth.service';
import { EmpresasPage } from '../pages/empresas/empresas';



@Component({
  templateUrl: 'app.html'
})
export class MyApp {
  @ViewChild(Nav) nav: Nav;

  rootPage: any = LoginPage;

  pages: Array<{ title: string, component: any }>;

  constructor(public platform: Platform, public statusBar: StatusBar, private auth: AuthService/*, public splashScreen: SplashScreen*/) {
    this.initializeApp();

    // used for an example of ngFor and navigation


    /*this.pages = [

      { title: 'Pacientes', component: HomePage },
      { title: 'Empresas', component: CompaniesPage },
      { title: 'Usuarios', component: UsersPage }
    ];*/

  }
  ionViewCanEnter() {
  }
  initializeApp() {
    this.platform.ready().then(() => {
      // Okay, so the platform is ready and our plugins are available.
      // Here you can do any higher level native things you might need.
      this.statusBar.styleDefault();
      //this.splashScreen.hide();
    });
  }

  openPage(page) {
    // Reset the content nav to have just this page
    // we wouldn't want the back button to show in this scenario
    // this.nav.push(page.component);//.setRoot(page.component);
    if (page == "HomePage") {
      this.nav.push(HomePage);//.setRoot(page.component);
    }
    else if (page == "CompaniesPage") {
      this.nav.push(CompaniesPage);
    }
    else if (page == "EmpresasPage") {
     
      this.nav.push(EmpresasPage);
    }
    else {
      this.nav.push(UsersPage);
    }
  }

  public cerrar() {
    this.auth.logout();
    this.nav.setRoot(LoginPage)
  }
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts